import { ShareMembershipInfoFragment, UserFragment } from 'gqlTypes'

export type Identifier = UserFragment['identifier'] | null | undefined

const isMemberCurrentUser = (
  memberIdentifier: Identifier,
  userIdentifier: Identifier
) => memberIdentifier === userIdentifier

export const getNameOrEmailFromMembership = (
  membership: ShareMembershipInfoFragment,
  userIdentifier: Identifier
) => {
  const user = membership.workspaceMembership?.user
  const email = membership.email

  if (isMemberCurrentUser(user?.identifier, userIdentifier)) {
    return `${user?.name || email} (You)`
  }

  return user?.name || email || ''
}
